import React from 'react';
import {compose} from "redux";
import {withRouter} from "react-router";

import styles from './FailureModal.module.scss';

import Phone from '../../../components/Phone/Phone';
import {TOLL_FREE_NUMBER} from '../../../settings/settings';
import config from '../../../config/config';
import errorMessageImg from '../../../assets/images/error-message.svg';

const FailureModal = ({onClose, history}) => {
  return (
    <div className={styles['loading-screen']}>
      <div className={styles['error-container']} id="errorContainer">
        <div className={styles.icon}>
          <img
            alt="errorpage-icon"
            src={errorMessageImg}
          />
        </div>
        <div className={styles.errorHeader}>
          We are having technical issues submitting your request.
        </div>
        <div className={styles.dash} />
        <div className={styles['error-msg']}>
          Call <span className="emphasis"><Phone phoneNumber={TOLL_FREE_NUMBER} /></span> (Monday to
          Friday: 8 a.m to 8 p.m. ET) to speak with <span className="orphan-line">a Financial Consultant.</span>
        </div>
        <button
          id="failure-modal-close"
          onClick={(e) => {
            //onClose();
            window.location.href=`${config.url}/usis/rmd-tool`;
          }}
          className={styles.stay}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default compose(withRouter)(FailureModal);
